import * as React from "react"
import type { SVGProps } from "react"
const SvgLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.82 12.15 3.9 3.9a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7 1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28l-4.6-4.6a1 1 0 0 1-.22-.33 1 1 0 0 1-.06-.37q0-.2.06-.38a1 1 0 0 1 .22-.32l4.6-4.6a1 1 0 0 1 .7-.28 1 1 0 0 1 .7.27 1 1 0 0 1 .28.7 1 1 0 0 1-.28.7z" />
  </svg>
)
export default SvgLeft
